module.exports = __webpack_public_path__ + "static/assets/1ab7d4941f535e9b84eab2965bda1780.svg";